import { Box, Card, Paragraph, ProgressBar } from '@zillow/constellation-10';

type Props = {
  covered: number;
  total: number;
};

export function RequirementsProgress({ covered, total }: Props) {
  const label = `${covered} of ${total} requested documents have files`;

  return (
    <Card
      elevated={false}
      css={{ paddingBlockEnd: 'tight' }}
      body={
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tighter' }}>
          <ProgressBar value={covered} maxValue={Math.max(total, 1)} aria-label={label} />
          <Paragraph textStyle="body-sm" color="text.subtle">
            {label}
          </Paragraph>
        </Box>
      }
    />
  );
}
